var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['v-image', _vm.isActive && 'v-image--active'],style:({ backgroundImage: !!_vm.src && `url('${_vm.src}')` }),attrs:{"aria-label":_vm.alt,"role":"img"}})
}
var staticRenderFns = []

export { render, staticRenderFns }